import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { GroupProposal } from '@/types/group-proposal';

type UpdateGroupProposalArg = {
  groupId: string;
  membersToAdd: string[];
  membersToRemove: string[];
};

type UpdateGroupProposalBody = {
  membersToAdd: string[];
  membersToRemove: string[];
};

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateGroupProposalArg }
): Promise<GroupProposal> => {
  const { groupId, membersToAdd, membersToRemove } = arg;

  const body: UpdateGroupProposalBody = {
    membersToAdd,
    membersToRemove,
  };

  return await denApi.post<GroupProposal, UpdateGroupProposalBody>(
    `admin/group/group-proposals/${encodeURIComponent(groupId)}/update`,
    body
  );
};

export function useUpdateGroupProposal(
  swrOptions?: SWRMutationConfiguration<
    GroupProposal,
    Error,
    string,
    UpdateGroupProposalArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    GroupProposal,
    Error,
    string,
    UpdateGroupProposalArg
  >('admin/group/group-proposals/update', fetcher, swrOptions);

  return { updateGroup: trigger, isLoading: isMutating, error };
}
